import * as types from './types';
import moment from 'moment';
import { get } from 'lodash';

const INITIAL_STATE = {
  activeApplication: {},
  isConfirmationReview: false,
  applicationFilters: {
    PagingDetails: {
      PageNumber: 1,
      PageSize: 20,
      Filter: [],
      SortColumn: [],
    },
    ShowIncomplete: false,
    ApplicationType: 'Active',
  },
  loading: true,
  loadingActiveApplications: true,
  availableToDecline: null,
  error: null,
  reprintedSuccessfully: null,
  autoPopulateStudentData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ACTIVE_APPLICATION_GET_STUDENTS:
      if (state.applicationFilters.ApplicationType !== action.payload.type) {
        return { ...state };
      }
      action.payload.data.Data.Result.forEach((x, index) => {
        //console.log(moment(x.ExpirationDate).format('MM/DD/YYYY'));
        if (x.HouseHouldSSN !== null && x.HouseHouldSSN !== '') {
          x.HouseHouldSSN =
            x.HouseHouldSSN.slice(0, 3) +
            '-' +
            x.HouseHouldSSN.slice(3, 5) +
            '-' +
            x.HouseHouldSSN.slice(5, 9);
        }
        if (x.ExpirationDate !== null && x.ExpirationDate !== '') {
          //must give input format or get warning
          x.ExpirationDate = moment(x.ExpirationDate, 'MM/DD/YYYY').format(
            'MM/DD/YYYY'
          );
        }
        if (x.ActualArchiveDate !== null && x.ActualArchiveDate !== '') {
          x.ActualArchiveDate = moment(x.ActualArchiveDate).format(
            'MM/DD/YYYY'
          );
        }
      });
      return {
        ...state,
        activeApplication: action.payload.data,
        isConfirmationReview: get(
          action.payload.data,
          'Data.IsConfirmationReview',
          'false'
        ),
      };
    case types.ACTIVE_APPLICATION_SAVE_FILTERS:
      return {
        ...state,
        applicationFilters: action.payload,
      };
    case types.MANAGE_APPLICATION_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.MANAGE_APPLICATION_ACTIVE_APPLICATIONS_LOADING:
      return {
        ...state,
        loadingActiveApplications: action.payload,
      };
    case types.MANAGE_APPLICATION_AVAILABLE_TO_DECLINE:
      return {
        ...state,
        availableToDecline: action.payload,
      };
    case types.ACTIVE_APPLICATION_GET_STUDENTS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.ACTIVE_APPLICATION_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.MANAGE_APPLICATION_REPRINTED_SUCCESSFULLY:
      return {
        ...state,
        reprintedSuccessfully: true,
      };
    case types.ACTIVE_APPLICATION_RESET_REPRINT_FLAG:
      return {
        ...state,
        reprintedSuccessfully: null,
      };
    case types.MANAGE_APPLICATION_SET_AUTO_POPULATE_STUDENT_DATA:
      return { ...state, autoPopulateStudentData: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/manageapplication/reducer.js